<template>
  <div>
    <!-- Navigation -->
    <navigation-bar></navigation-bar>

    <!-- Hauptinhalt -->
    <div class="container-fluid mt-4">
      <!-- Kopfzeile mit Werten aus postData -->
      <h3>
        Heti megrendelések
        <small class="text-muted">
          (fuvarszervező: {{ postData.fsz }}, {{ postData.ev }}/{{ postData.het }} hét)
        </small>
      </h3>

      <!-- Tabelle mit Scrollbalken -->
      <div class="table-responsive-wrapper">
        <table class="table table-striped">
          <thead class="sticky-header">

            <tr>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.m_az" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.megrendelo" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.felrako" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.fhely" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.lerako" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.lhely" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.cikk" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.m_datumtol" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.m_suly" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.m_km" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.hivatkozasi_szam" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.m_aregysegar" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.mar_egysegar" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.gmp" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.megjegyzes" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.belsoHivatkozas" type="text" class="form-control" />
                </div>
              </th>
            </tr>


            <tr>
              <th>VIR AZ</th>
              <th>Megrendelő</th>
              <th>Felrakó</th>
              <th>Felrakó-hely</th>
              <th>Lerakó</th>
              <th>Lerakó-hely</th>
              <th>Cikk</th>
              <th>Dátum</th>
              <th>Súly</th>
              <th>KM</th>
              <th>Hivatkozási szám</th>
              <th>Nagyár</th>
              <th>Kisár</th>
           
              <th>GMP</th> <!-- Neue GMP-Spalte -->
              <th>Megjegyzés</th>
              <th>Belső hivatkozás</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in filteredOrders" :key="order.az" @click="openOrderDetails(order)">
              <td>{{ order.m_az }}</td>
              <td>{{ order.megrendelo }}</td>
              <td>{{ order.felrako }}</td>
              <td>{{ order.fhely }}</td>
              <td>{{ order.lerako }}</td>
              <td>{{ order.lhely }}</td>
              <td>{{ order.cikk }}</td>
              <td>{{ order.m_datumtol }}</td>
              <td>{{ order.m_suly }}</td>
              <td class="km-cell">
                <span>{{ order.m_km }}</span>

                <span v-if="hasPont(order)" class="text-muted">
                  ({{ formatPont0(order.pontvonal_hossz) }})
                </span>

                <button
                  v-if="hasPolyline(order)"
                  type="button"
                  class="btn btn-link btn-sm p-0 ml-2"
                  title="Térkép"
                  @click.stop="openUtvonalModal(order)"
                >
                  <i class="fas fa-map-marked-alt"></i>
                </button>
              </td>

              <td>{{ order.hivatkozasi_szam }}</td>
              <td>{{ order.m_aregysegar }} {{ cleanEgysgarme(order.m_egysegarme) }}</td>
              <td>{{ order.mar_egysegar }} {{ cleanEgysgarme(order.mar_egysegarme) }}</td>
           

              <td>
                <input type="checkbox" disabled :checked="order.gmp === -1" />
              </td> <!-- Häkchen basierend auf GMP-Wert -->

              <td>{{ order.megjegyzes }}</td>
              <td>{{ order.belsoHivatkozas }}</td>
            </tr>
          </tbody>
        </table>

      <!-- Modal: Útvonal térkép -->
      <div v-if="showUtvonalModal" class="utvonal-modal" @click.self="closeUtvonalModal">
        <div class="utvonal-modal-content">
          <button class="close-button-inside" @click="closeUtvonalModal">&times;</button>

          <h5 class="mb-2">
            {{ modalTitle }}
            <small v-if="modalPontKm !== null" class="text-muted">
              — pontvonal_hossz: <b>{{ formatPont0(modalPontKm) }}</b> km
            </small>
          </h5>

          <div id="utvonal-modal-map" style="height: 70vh; width: 100%;"></div>
        </div>
      </div>




      </div>

      <!-- Zurück-Button -->
      <button class="btn btn-secondary m-3" @click="goBack">← Vissza</button>
      <button class="btn btn-secondary m-3" @click="resetFilters">Szűrők visszaállítása</button>
    </div>
  </div>
</template>

<script>
import axiosInstance from "@/axiosInstance";

import { mapMutations } from 'vuex'; // Dies ist der richtige Platz für den Import
import L from "leaflet";
import "leaflet/dist/leaflet.css";



export default {
  data() {
    return {
      weeklyOrders: [], // Liste der wöchentlichen Bestellungen
      filters: {
        m_az: "",
        megrendelo: "",
        felrako: "",
        fhely: "",
        lerako: "",
        lhely: "",
        cikk: "",
        m_datumtol: "",
        m_suly: "",
        m_km: "",
        hivatkozasi_szam: "",
        m_aregysegar: "",
        mar_egysegar: "",
        gmp: "",
        megjegyzes: "",
        belsoHivatkozas: "",
      },

      showUtvonalModal: false,
      modalPolyline: null,
      modalPontKm: null,
      modalTitle: "",
      utvonalMap: null,


    };
  },

//--------------------------------

  computed: {
    // Hole die postData direkt aus dem Vuex-Store
    postData() {
      return this.$store.getters.getWeekPostData || {};
    },
    filteredOrders() {
  return this.weeklyOrders.filter((order) => {
    return Object.keys(this.filters).every((key) => {
      const filterValue = this.filters[key]?.toLowerCase();
      if (!filterValue) return true;

      // ✅ KM-Filter: m_km + pontvonal_hossz gemeinsam durchsuchen
      let orderValue = "";
      if (key === "m_km") {
        const km = order?.m_km ?? "";
        const pont = order?.pontvonal_hossz ?? "";
        orderValue = `${km} ${pont}`.toString().toLowerCase();
      } else {
        orderValue = (order?.[key]?.toString().toLowerCase() || "");
      }

      return orderValue.includes(filterValue);
    });
  });
},


  },
  async mounted() {
    this.fetchWeeklyOrders();
  },

//-------------------------

  methods: {
    ...mapMutations(['setorderData']), // Nutze mapMutations, um die Mutation in die Komponente zu integrieren
   
   
hasPont(order) {
  const n = Number(order?.pontvonal_hossz);
  return Number.isFinite(n) && n > 0;
},
hasPolyline(order) {
  return !!(order?.polyline && String(order.polyline).trim().length > 0);
},
formatPont0(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return "";
  return n.toFixed(0);
},

openUtvonalModal(order) {
  if (!this.hasPolyline(order)) return;

  this.modalPolyline = order.polyline;
  this.modalPontKm = (order.pontvonal_hossz ?? null);
  this.modalTitle = `Útvonal – VIR AZ: ${order.m_az ?? order.az ?? ""}`;

  this.showUtvonalModal = true;

  this.$nextTick(() => {
    this.initUtvonalMap();
  });
},

closeUtvonalModal() {
  this.showUtvonalModal = false;

  if (this.utvonalMap) {
    this.utvonalMap.remove();
    this.utvonalMap = null;
  }

  this.modalPolyline = null;
  this.modalPontKm = null;
  this.modalTitle = "";
},

initUtvonalMap() {
  const encoded = this.modalPolyline;
  if (!encoded) return;

  if (this.utvonalMap) {
    this.utvonalMap.remove();
    this.utvonalMap = null;
  }

  const coords = this.decodePolyline(encoded, 5);
  if (!coords.length) return;

  const latLngs = coords.map(([lat, lng]) => [lat, lng]);

  this.utvonalMap = L.map("utvonal-modal-map", { preferCanvas: true });

  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 19,
    attribution: "&copy; OpenStreetMap contributors",
  }).addTo(this.utvonalMap);

  const line = L.polyline(latLngs, { weight: 4 }).addTo(this.utvonalMap);

  // Start/End als CircleMarker (kein Icon-Problem)
  L.circleMarker(latLngs[0], { radius: 6 }).addTo(this.utvonalMap).bindPopup("Start");
  L.circleMarker(latLngs[latLngs.length - 1], { radius: 6 }).addTo(this.utvonalMap).bindPopup("Cél");

  this.utvonalMap.fitBounds(line.getBounds(), { padding: [20, 20] });
  setTimeout(() => this.utvonalMap && this.utvonalMap.invalidateSize(), 0);
},

decodePolyline(encoded, precision = 5) {
  if (!encoded || typeof encoded !== "string") return [];

  let index = 0, lat = 0, lng = 0;
  const coordinates = [];
  const factor = Math.pow(10, precision);

  while (index < encoded.length) {
    let result = 0, shift = 0, b;

    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    const deltaLat = (result & 1) ? ~(result >> 1) : (result >> 1);
    lat += deltaLat;

    result = 0; shift = 0;

    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    const deltaLng = (result & 1) ? ~(result >> 1) : (result >> 1);
    lng += deltaLng;

    coordinates.push([lat / factor, lng / factor]);
  }

  return coordinates;
},


   
   //-------------
    resetFilters() {
      this.filters = {
        m_az: "",
        megrendelo: "",
        felrako: "",
        fhely: "",
        lerako: "",
        lhely: "",
        cikk: "",
        m_datumtol: "",
        m_suly: "",
        m_km: "",
        hivatkozasi_szam: "",
        m_aregysegar: "",
        mar_egysegar: "",
        gmp: "",
        megjegyzes: "",
        belsoHivatkozas: "",
      };
    },
    openOrderDetails(order) {
    
        const orderData = {
              napifo_az: order.az
        };

            // Speichere die Daten im Store
            this.setorderData(orderData);

    this.$router.push({ name: 'orderDetails' }); // Navigiere zur `orderDetails.vue`
  },

    cleanEgysgarme(value) {
      return value ? value.replace(/Fuvar -/g, "").trim() : value;
    },

    async fetchWeeklyOrders() {
      const postData = this.$store.getters.getWeekPostData;

        if (!postData || !postData.ceg_az || !postData.fsz) {
          console.error('Keine gültigen postData im Store gefunden.');
          return;
        }

      try {
        console.log("WEEKLY Post Data:", postData);
        const response = await axiosInstance.post("/megrendeles/heti_lista.php", postData);

        if (response.status === 200 && response.data && response.data.data) {
          this.weeklyOrders = response.data.data;
          console.log("Weekly Orders:", this.weeklyOrders);
        } else {
          console.error("Fehler beim Abrufen der wöchentlichen Bestellungen:", response);
        }
      } catch (error) {
        console.error("API-Fehler:", error);
      }
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>

.table-responsive-wrapper {
  max-height: 700px; /* Maximale Höhe der Tabelle mit Scrollbalken */
  overflow-y: auto;  /* Vertikaler Scrollbalken */
  position: relative;
}

.sticky-header th {
  position: sticky;  /* Sticky macht die Kopfzeile fixiert */
  top: 0;            /* Hält die Kopfzeile oben */
  background-color: white; /* Hintergrundfarbe der Kopfzeile */
  z-index: 2;        /* Sicherstellen, dass die Kopfzeile vor den Daten bleibt */
}

.table {
  min-width: 1500px; /* Erhöhte Mindestbreite für horizontales Scrollen */
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 3px; /* Weniger Padding für kompaktere Darstellung */
  text-align: left;
  border: 1px solid #ddd; /* Rahmen */
  font-size: 12px; /* Kleinere Schriftgröße */
}

h3 {
  margin-bottom: 10px;
}

.input-with-icon {
  position: relative; /* Ermöglicht die absolute Positionierung des Icons */
}

.input-with-icon i {
  position: absolute;
  top: 50%; /* Vertikal zentrieren */
  left: 10px; /* Abstand zum linken Rand */
  transform: translateY(-50%);
  color: #6c757d; /* Graue Farbe für das Icon */
}

.input-with-icon input {
  padding-left: 30px; /* Platz für das Icon schaffen */
  font-size: 12px; /* Kleinere Schriftgröße */
  height: 30px; /* Optional: Reduziere die Höhe des Eingabefelds */
}

.utvonal-modal {
  position: fixed;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
}

.utvonal-modal-content {
  position: relative;
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 85%;
  max-height: 85%;
  overflow-y: auto;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
}

.close-button-inside {
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 15px;
  cursor: pointer;
  color: #333;
}

.km-cell {
  white-space: nowrap;
}



</style>